import { useEffect, useRef } from "react";

const ACTIVITY_EVENTS = [
  "mousedown",
  "mousemove",
  "keydown",
  "scroll",
  "touchstart",
  "wheel",
];

const DEFAULT_DEBOUNCE_MS = 1500;

/**
 * Detects genuine in-portal user activity. Visibility changes are not activity.
 * RUNNING callbacks are throttled to 1.5s; AUTO_PAUSED can pass a shorter debounce.
 */
export function useActivityDetection(onActivity, { enabled = true, debounceMs = DEFAULT_DEBOUNCE_MS } = {}) {
  const onActivityRef = useRef(onActivity);
  onActivityRef.current = onActivity;
  const debounce = Math.max(0, Number(debounceMs) || 0);

  useEffect(() => {
    if (!enabled || typeof window === "undefined") return undefined;

    let lastFired = 0;
    const handle = () => {
      const now = Date.now();
      if (debounce > 0 && now - lastFired < debounce) return;
      lastFired = now;
      onActivityRef.current?.();
    };

    ACTIVITY_EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, handle, { passive: true });
    });

    return () => {
      ACTIVITY_EVENTS.forEach((eventName) => {
        window.removeEventListener(eventName, handle);
      });
    };
  }, [debounce, enabled]);
}
